export default "https://legacy.eskolare-development.com/images/socialImage.png";